import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SettingCard, SettingFullRow, } from 'z3k-settings/components/material-utils/settings-card';
import { ControlWithoutValidation } from 'shared/components/fields/control/without-validation';
import { MaterialDropdown } from 'shared/components/fields';
import { useContext, useMemo } from 'react';
import { SchedulePeriod } from './schedule-period';
import { useHeatingCircuitsItemState } from 'z3k-settings/climatic/heating-circuits-item/lib/useHeatingCircuitsItemState';
import { Z3KSettingsEditor } from 'z3k-settings/provider/types';
export function ScheduleCard() {
    const { timetable, time_intervals, start_times, end_times, circuit, heating_modes } = useHeatingCircuitsItemState();
    if (timetable == null)
        return null;
    const { config, replace_config } = useContext(Z3KSettingsEditor);
    const intervals = useMemo(() => timetable.time_intervals
        .map((interval_id) => time_intervals.find((int) => int.id === interval_id))
        .filter((interval) => interval != null), [timetable, time_intervals]);
    const mode_options = useMemo(() => heating_modes
        .map((mode) => [
        mode,
        mode.heating_zones.find((zone) => zone.heating_circuit === circuit.id),
    ])
        .filter(([, zone]) => zone != null)
        .filter(([, zone]) => zone?.temperature_setting !== timetable.id)
        .map(([mode]) => ({ text: mode.name, value: mode.id })), [heating_modes, timetable]);
    const schedule_periods = useMemo(() => intervals.map((interval, period_number) => {
        return (_jsx(SettingFullRow, { children: _jsx(SchedulePeriod, { period_number: period_number + 1, mode_options: mode_options, start_time: start_times[interval.id], end_time: end_times[interval.id], interval: interval }) }, period_number));
    }), [intervals /*onChangeTabState*/, start_times, end_times, mode_options]);
    return (_jsxs(SettingCard, { title: "\u0420\u0430\u0441\u043F\u0438\u0441\u0430\u043D\u0438\u0435", children: [schedule_periods, _jsx(ControlWithoutValidation, { label: "\u0424\u043E\u043D\u043E\u0432\u044B\u0439 \u0440\u0435\u0436\u0438\u043C", value: timetable.outside_default, onChange: (value) => {
                    replace_config({
                        ...config,
                        interval_timetables: config.interval_timetables.map((item) => {
                            if (item.id === timetable.id) {
                                return {
                                    ...item,
                                    outside_default: value,
                                };
                            }
                            return item;
                        }),
                    });
                }, field: (input_props) => (_jsx(MaterialDropdown, { variant: "outlined", options: mode_options, ...input_props })) })] }));
}
